module.exports = __webpack_public_path__ + "img/2D8753_5CD6A5_45BB82_4CC494-256px.207f2670.png";